export function initialize(selector) {
    $(".group4").colorbox({
        rel: 'group4',
        slideshow: true,
        slideshowSpeed: 5000,
        photo: true,
        width: "90%",
        height: "90%",
        opacity: 0.8
    });

    $.colorbox.resize();
}


export default {};
